import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import Constants from '../../../components/Constants/';
import FileBase64 from 'react-file-base64';
import Select from 'react-select';

import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class GroupForm extends Component {

  constructor(props) {
    super(props);

    this.refreshGroup = this.refreshGroup.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);

    this.updateSelectValue = this.updateSelectValue.bind(this);
    this.updateUserInputValue = this.updateUserInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.onImageSelect = this.onImageSelect.bind(this);

    this.onClientSelect = this.onClientSelect.bind(this);
    this.onDoctorSelect = this.onDoctorSelect.bind(this);

    this.saveGroup = this.saveGroup.bind(this);

    this.state = {
        groupId: this.props.match.params.groupId,
        group: null,
        groupList: [],

        doctorList: [],
        clientList: [],

        selectDoctorValue: [],
        selectClientValue: []
    };
      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }
    }

    componentDidMount(){

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/group'
      })
      .then(response => {

        let groupsList = [];
        response.data.forEach(function(group) {
          groupsList.push({
            value: group.id,
            label: group.name
          });
        });

        this.setState({groupList: groupsList});
      });

      //Busca Médicos
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/doctor'
      })
      .then(response => {

        let doctorsList = [];
        response.data.forEach(function(doctor) {
          doctorsList.push({
            value: doctor.id,
            label: doctor.name
          });
        });

        this.setState({doctorList: doctorsList});
      });

      //Busca Clientes
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/client'
      })
      .then(response => {

        let clientsList = [];
        response.data.forEach(function(client) {
          clientsList.push({
            value: client.id,
            label: client.name
          });
        });

        this.setState({clientList: clientsList});
      });


      this.refreshGroup();
    }

    refreshGroup(){

      if(this.props.match.params.groupId == null ){

        let blankGroup = {
          id: null,
          name: "",
          code: "",
          doctors: "",
          clients: "",

          parentGroupTimeCondition: "",
          parentGroup: {
            id: null
          }
        };

        this.setState({
            group: blankGroup
        });

      }else{
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/group/'+this.props.match.params.groupId
        })
        .then(response => {
            let clientsStr = "";
            response.data.clients.forEach(function(client){
              if(clientsStr == ""){
                clientsStr += client.id;
              }else{
                clientsStr += ','+client.id;
              }
            });

            let doctorsStr = "";
            response.data.doctors.forEach(function(doctor){
              if(doctorsStr == ""){
                doctorsStr += doctor.id;
              }else{
                doctorsStr += ','+doctor.id;
              }
            });

            this.setState({
              selectClientValue: clientsStr,
              selectDoctorValue: doctorsStr,
              group: response.data
            });
        });
      }
    }

    saveGroup(){

      let errorMessages = "";
      if(this.state.group.name == ""){
        errorMessages += "O campo Nome é obrigatório. \r\n";
      }

      if(errorMessages != ""){
        this.msg.show(errorMessages, {
          time: 10000,
          type: 'success'
        });

        return false;
      }

      let clients = [];
      let doctors = [];
      let tokens = "";

      if(this.state.selectClientValue != ""){
        tokens = this.state.selectClientValue.split(',');
        tokens.forEach(function(client) {
          clients.push({id: client});
        }, this);
      }
      if(this.state.selectDoctorValue != ""){
        tokens = this.state.selectDoctorValue.split(',');
        tokens.forEach(function(doctor) {
          doctors.push({id: doctor});
        }, this);
      }

      let actualGroup = this.state.group;
      actualGroup.clients = clients;
      actualGroup.doctors = doctors;

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/group',
          data: this.state.group
      })
      .then(response => {
          history.replace("groups");
      });
    }

    updateSelectValue(newValue) {
      let actualGroup = this.state.group;

      if(actualGroup.parentGroup){
        actualGroup.parentGroup.id = newValue;
      }else{
        actualGroup.parentGroup = {"id": newValue};
      }

  		this.setState({
  			group: actualGroup
  		});
  	}

    updateInputValue(evt, input) {
      let actualGroup = this.state.group;
      actualGroup[input] = evt.target.value;

      this.setState({
        group: actualGroup
      });
    }

    updateCheckboxValue(evt, input) {
      let actualGroup = this.state.group;
      actualGroup[input] = !actualGroup[input];

      this.setState({
        group: actualGroup
      });
    }

    updateUserInputValue(evt, input) {
      let actualGroup = this.state.group;
      actualGroup.user[input] = evt.target.value;

      this.setState({
        group: actualGroup
      });
    }

    onImageSelect(file) {
      let actualGroup = this.state.group;
      actualGroup.signature = file.base64.replace("data:image/JPEG;base64,", "").replace("data:image/png;base64,", "");
      actualGroup.signatureFileName = file.name;
      this.setState({group: actualGroup});
    }

    onClientSelect (value) {

      let actualClients = this.state.selectClientValue;
      let actualClientsArray = this.state.selectClientValue.split(',');
      let tokens = value.split(',');

      //adicionar
      if(tokens.length > actualClientsArray.length){
        if(tokens[tokens.length-1] != "" && tokens[tokens.length-1] != undefined){
          this.msg.show("Adicionando cliente neste grupo. Isso pode demorar algum tempo.", {
            time: 10000,
            type: 'info'
          });

          axios({
              method: 'post',
              headers: {
                  'Content-Type': 'text/plain'
              },
              url: Constants.apiUrl+'/api/v1/group/addClient/'+this.state.group.id,
              data: tokens[tokens.length-1]
          })
          .then(response => {
            this.msg.show("Cliente adicionado ao grupo.", {
              time: 10000,
              type: 'success'
            });
          });
        }
      }else if(tokens.length < actualClientsArray.length || (tokens.length == actualClientsArray.length && tokens[0] == "")){

        actualClientsArray.forEach(function(client) {
          if(tokens.indexOf(client) < 0){
            this.msg.show("Removendo cliente deste grupo. Isso pode demorar algum tempo.", {
              time: 10000,
              type: 'info'
            });
            //Remove cliente do Grupo
            axios({
                method: 'delete',
                url: Constants.apiUrl+'/api/v1/group/removeClient/'+this.state.group.id+'/'+client
            })
            .then(response => {
              this.msg.show("Cliente removido do grupo.", {
                time: 10000,
                type: 'success'
              });
            });
          }
        }, this);
      }

      this.setState({ selectClientValue: value });


  	}

    onDoctorSelect (value) {
      this.setState({ selectDoctorValue: value });

      let actualDoctors = this.state.selectDoctorValue;
      let actualDoctorsArray = this.state.selectDoctorValue.split(',');
      let tokens = value.split(',');

      //adicionar
      if(tokens.length > actualDoctorsArray.length){
        if(tokens[tokens.length-1] != "" && tokens[tokens.length-1] != undefined){

          axios({
              method: 'post',
              headers: {
                  'Content-Type': 'text/plain'
              },
              url: Constants.apiUrl+'/api/v1/group/addDoctor/'+this.state.group.id,
              data: tokens[tokens.length-1]
          })
          .then(response => {
            this.msg.show("Médico adicionado ao grupo.", {
              time: 10000,
              type: 'success'
            });
          });
        }
      }else if(tokens.length < actualDoctorsArray.length || (tokens.length == actualDoctorsArray.length && tokens[0] == "")){

        actualDoctorsArray.forEach(function(doctor) {
          if(tokens.indexOf(doctor) < 0){

            //Remove cliente do Grupo
            axios({
                method: 'delete',
                url: Constants.apiUrl+'/api/v1/group/removeDoctor/'+this.state.group.id+'/'+doctor
            })
            .then(response => {
              this.msg.show("Médico removido do grupo.", {
                time: 10000,
                type: 'success'
              });
            });
          }
        }, this);
      }
  	}

    render() {

      if(this.state.group == null) return null;

      return(
          <div>
            <h2>Grupo</h2>
            <hr />
            <Row>
              <Col xs="6" md="6">
                  <Label>Nome</Label>
                  <Input type="text" id="name" ref="name" value={this.state.group.name}
                    onChange={evt => this.updateInputValue(evt, "name")} placeholder="Nome"/>
              </Col>

              <Col xs="6" md="6">
                <Label>Código</Label>
                <Input type="text" id="code" ref="code" value={this.state.group.code}
                  onChange={evt => this.updateInputValue(evt, "code")} placeholder="Código"/>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs="6" md="4">
                <Label>Subgrupo de</Label>

                <Select
                  id="parentGroup"
                  ref="parentGroup"
                  autoFocus
                  options={this.state.groupList}
                  simpleValue
                  clearable={this.state.clearable}
                  name="parentGroup"
                  value={this.state.group.parentGroup == null ? '' : this.state.group.parentGroup.id}
                  onChange={this.updateSelectValue}
                  openOnClick={true}
                  searchable={true}
                />
              </Col>

              <Col xs="6" md="4">
                <Label>Condição</Label>
                <Input type="text" id="parentGroupTimeCondition" ref="parentGroupTimeCondition" value={this.state.group.parentGroupTimeCondition}
                  onChange={evt => this.updateInputValue(evt, "parentGroupTimeCondition")} placeholder="Condição"/>
                <span className="help">Ex.: dom|seg[00:00-06:59]|sex[00:00-06:59][19:00-23:59]|sab</span>
              </Col>

            </Row>
            <hr />


            <hr />
            <small>Alterações em Clientes e Médicos são sincronizadas automaticamente.</small>
            <Row>
              <Col xs="6" md="6">
                <Label>Clientes</Label>

                <Select
        					closeOnSelect={false}
        					multi
        					onChange={this.onClientSelect}
        					options={this.state.clientList}
        					placeholder="Clientes"
                  removeSelected={true}
                  simpleValue
    					    value={this.state.selectClientValue}
        				/>
              </Col>

              <Col xs="6" md="6">
                <Label>Médicos</Label>

                <Select
        					closeOnSelect={false}
        					multi
        					onChange={this.onDoctorSelect}
        					options={this.state.doctorList}
        					placeholder="Médicos"
                  removeSelected={true}
                  simpleValue
    					    value={this.state.selectDoctorValue}
        				/>
              </Col>
            </Row>

            <br />
            <Button color="success" onClick={() => { this.saveGroup(); }}>Salvar Grupo</Button>
            <br />
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default GroupForm;



// WEBPACK FOOTER //
// ./src/views/admin/GroupForm/GroupForm.js